// removed by extract-text-webpack-plugin
module.exports = {"breadCrumb":"breadCrumb__3Rvc1","markerBreadCrumb":"markerBreadCrumb__3tHnA","inactiveCrumb":"inactiveCrumb__3H1EG","activeCrumb":"activeCrumb__1C_fp"};


//////////////////
// WEBPACK FOOTER
// ./components/urlBreadCrumb/style.scss
// module id = WhrM
// module chunks = 17